import type { CollectionPreview } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc';
import { GET_ALL_COLLECTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc.dfc.new';
import { GET_ALL_COLLECTIONS_QUERY as PUBLIC_GET_ALL_COLLECTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc-external.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';

export type { CollectionPreview };

// The DS lib CollectionCard resolves ecosystem.hubspot.com/marketplace URLs to
// in-app router paths (dropping the portal ID base) for both the CTA and the
// preview-item links. Build URLs in that shape so navigation works in the
// in-app and public storefronts without a custom link component.
const ECOSYSTEM_MARKETPLACE_BASE = 'https://ecosystem.hubspot.com/marketplace';

export function useDiscoveryCollections({ skip }: { skip?: boolean } = {}) {
  const { data, loading, error } = useAppContextQuery({
    app: GET_ALL_COLLECTIONS_QUERY,
    public: PUBLIC_GET_ALL_COLLECTIONS_QUERY,
    options: { skip },
  });

  return {
    collections: data?.result?.items ?? [],
    loading,
    error,
  };
}

export interface DSCollectionPreviewItem {
  listingId: string;
  name: string;
  iconUrl?: string;
  listingUrl?: string;
}

interface DSListingCardPreview {
  listingId: number;
  name: string;
  slug: string;
  iconUrl: string;
}

/** Maps DS preview items to the shape the DS lib CollectionCard expects,
 * linking each preview icon to its listing detail page. */
export function adaptDSPreviewItems(
  previewItems: DSListingCardPreview[]
): DSCollectionPreviewItem[] {
  return previewItems.map((item) => ({
    listingId: String(item.listingId),
    name: item.name,
    iconUrl: item.iconUrl || undefined,
    listingUrl: getListingUrl(item.slug),
  }));
}

export function getCollectionUrl(slug: string): string {
  return `${ECOSYSTEM_MARKETPLACE_BASE}/featured/${slug}`;
}

export function getListingUrl(slug: string): string {
  return `${ECOSYSTEM_MARKETPLACE_BASE}/listing/${slug}`;
}
